import { FolderOpenTwoTone, DownloadOutlined, UploadOutlined, SaveOutlined, CloseOutlined, ReloadOutlined, UndoOutlined, SendOutlined, CheckOutlined } from '@ant-design/icons';
import { Col, Row, Tabs, Table, Form, Space, DatePicker, Button, Tooltip, Tag, Input } from 'antd';
import type { DataNode } from 'antd/es/tree';
import { useEffect, useState } from "react";
import { toast } from 'react-toastify';
import { ContentHeader } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { layMauChamNgoaiGio, importFileNgoaiGio, luuChamNgoaiGio, layNgoaiGio, xoaNgoaiGio, taiDuLieuChamNgoaiGio, thuHoiNgoaiGio, lDPhongDuyetNgoaiGio, lDPhuTrachDuyetNgoaiGio, trinhLDPhongNgoaiGio } from "@app/services/chamcong";
import DonViSelectTree from "@pages/utils/DonViSelectTree";
import Dropzone from "react-dropzone";
import { ImportFileChamCongRequest } from "@app/models/chamcong/FileChamCongRequest";
import { useForm } from 'antd/es/form/Form';
import { dateCommon, validateMessages } from '../../helpers/common';
import ModalTextForm from '../../components/modal/ModalTextForm';
import { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';
import { Links } from '../../helpers/Links';
import { menuHelper } from '../../helpers/account';
import { CongNgoaiGioNhanVien } from '../../models/chamcong/ChamNgoaiGio';
import { useNavigate } from 'react-router-dom';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import { InputNumber } from 'antd/lib';
import { loaiNgoaiGio, trangThaiChamCong } from '../../constants';
import LogNguoiDungTable from '../utils/LogNguoiDungTable';
import { LogNguoiDung } from '../../models/lognguoidung/LogNguoiDung';

const { TextArea } = Input;

const convertDataTreeView = (data: any) => {
    let chidlrenArr: Array<DataNode> = [];
    if (data) {
        chidlrenArr = data.map((_item: any) => {
            let rs: DataNode = {

                key: _item?.id,
                title: _item?.tenChucNang,
                icon: <FolderOpenTwoTone style={{ fontSize: "20px" }} rev="" />,
                children: convertDataTreeView(_item?.children)
            }
            return rs;
        });
    }
    return chidlrenArr;
}

const columnsDefault: ColumnsType<CongNgoaiGioNhanVien> = [
    {
        title: "Họ tên",
        key: "tenNhanVien",
        dataIndex: "tenNhanVien",
        fixed: 'left',
        width: "200px"
    },
    {
        title: "Chức vụ",
        key: "tenChucVu",
        dataIndex: "tenChucVu",
        fixed: 'left',
        width: "150px"
    },
];

const ChamNgoaiGio = () => {
    const [form] = useForm();
    const user = useSelector((state: any) => state.auth.currentUser);
    const [file, setFile] = useState<any>();
    const [isReloadPage, setIsReloadPage] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [idChamCong, setIdChamCong] = useState<number>(0);
    const [idNhanVien, setIdNhanVien] = useState<number>(0);
    const [idDonVi, setIdDonVi] = useState<number>(0);
    const [trangThai, setTrangThai] = useState<number>(-1);
    const [dataChamCong, setDataChamCong] = useState<Array<CongNgoaiGioNhanVien>>();
    const [tongNgayTrongThang, setTongNgayTrongThang] = useState(0);
    const [dsNgayThuTheoThang, setDSNgayThuTheoThang] = useState<any>();
    const [isLoading, setIsLoading] = useState(false);
    const [tableColumns, setTableColumns] = useState<ColumnsType<CongNgoaiGioNhanVien>>(columnsDefault);
    const [confirmModal, setConfirmModal] = useState<any>({});
    const [traLaiModal, setTraLaiModal] = useState<boolean>(false);
    const [lyDoTraLai, setLyDoTraLai] = useState<string>("");
    const [logs, setLogs] = useState<Array<LogNguoiDung>>([]);
    const [showDetail, setShowDetail] = useState(true);

    const menu: any = menuHelper.checkMultiPermission([
        Links.ChamCong.QuanTriChamNgoaiGio,
        Links.ChamCong.ThemNgoaiGio,
        Links.ChamCong.DuyetNgoaiGio,
        Links.ChamCong.XoaNgoaiGio,
        Links.ChamCong.TrinhNgoaiGio,
        Links.ChamCong.LDPhongDuyetNgoaiGio,
        Links.ChamCong.LDPhuTrachDuyetNgoaiGio
    ]);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const taiFileMau = async () => {
        form.validateFields()
            .then(async (values) => {
                dispatch(showLoadingScreen());
                try {
                    var response = await layMauChamNgoaiGio({
                        idDonVi: values.idDonVi,
                        thangNam: dateCommon.formatDate(values.thang.$d, "MM/yyyy")
                    });
                    let link = document.createElement('a');
                    link.download = `MauChamNgoaiGio.xlsx`;
                    let blob = new Blob([response.data], { type: response.data.type });
                    link.href = URL.createObjectURL(blob);
                    link.click();
                    URL.revokeObjectURL(link.href);
                } catch (error: any) {
                    toast.error(error || 'Có lỗi xảy ra');
                }

                dispatch(hideLoadingScreen());
            })
            .catch((values) => { });
    }

    const handleFileChange = (files: any) => {
        form.validateFields().then((values) => {
            try {
                if (files.length > 0) {
                    const selectedFile = files[0];
                    if (selectedFile.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                        setFile(selectedFile);
                    } else {
                        alert("Vui lòng chọn một file Excel (định dạng .xlsx).");
                    }
                }
            } catch (error: any) {
                toast.error(error || 'Có lỗi xảy ra');
            }

            setShowModal(true);
        }).catch((e) => {
            setShowModal(false);
        });

    };

    const handleUpload = async () => {
        setShowModal(false);
        if (file) {
            form.validateFields().then(async (values) => {
                const formData = new FormData();
                formData.append('file', file);
                var request: ImportFileChamCongRequest = {
                    file: file,
                    idDonVi: values.idDonVi,
                    thangNam: dateCommon.formatDate(values.thang.$d, "MM/yyyy")
                }

                try {
                    var response = await importFileNgoaiGio(request);
                    setDataChamCong(response);
                    setTongNgayTrongThang(response.length > 0 ? response[0].ngoaiGio.length : 0);
                    setDSNgayThuTheoThang(response[0].ngoaiGio);
                    toast.success("Import dữ liệu chấm công thành công");
                    setFile(null);
                } catch (error) {
                    setShowModal(false);
                    setFile(null);
                    toast.error("Không thể import file. Vui lòng thử lại sau");
                }
            });
        } else {
            toast.error('Vui lòng chọn một tệp tin để tải lên.');
        }
    };

    const taiDuLieuChamCong = async () => {
        form.validateFields()
            .then(async (values) => {
                dispatch(showLoadingScreen());
                setIsLoading(true);
                try {
                    var response = await taiDuLieuChamNgoaiGio({
                        idDonVi: values.idDonVi,
                        thangNam: dateCommon.formatDate(values.thang.$d, "MM/yyyy")
                    });
                    setDataChamCong(response);
                    setTongNgayTrongThang(response.length > 0 ? response[0].ngoaiGio.length : 0);
                    setDSNgayThuTheoThang(response[0].ngoaiGio);
                } catch (error: any) {
                    toast.error(error || 'Có lỗi xảy ra');
                }
                setIsLoading(false);
                dispatch(hideLoadingScreen());
            })
            .catch((values) => { });
    }

    const renderColumnsTable = async () => {
        const columns: ColumnsType<CongNgoaiGioNhanVien> = [...columnsDefault];
        for (var i = 0; i < tongNgayTrongThang; i++) {
            const idx = i;
            columns.push({
                title: () => (
                    <span>
                        {(idx + 1)}<br /> {dsNgayThuTheoThang[idx].thu || ""}
                    </span>
                ),
                key: "ngayCong[" + i + "]",
                align: "center",
                render: (value, record, index) => {
                    const ngoaiGio = record.ngoaiGio[idx];
                    if (trangThai == trangThaiChamCong.trinhLDPhong || trangThai == trangThaiChamCong.trinhLDPhuTrach || trangThai == trangThaiChamCong.lDPhuTrachTraLai || trangThai == trangThaiChamCong.lDPhuTrachDuyet) {
                        switch (ngoaiGio.loaiNgoaiGio) {
                            case 1:
                                return (<Tooltip title="Ngày thường"><Tag color="default">{ngoaiGio.soGio}</ Tag></Tooltip>);
                            case 2:
                                return (<Tooltip title="Cuối tuần"><Tag color="processing">{ngoaiGio.soGio}</ Tag></Tooltip>);
                            case 3:
                                return (<Tooltip title="Ngày lễ"><Tag color="success">{ngoaiGio.soGio}</ Tag></Tooltip>);

                        }
                    } else {
                        var color = "#d9d9d9";
                        switch (ngoaiGio.loaiNgoaiGio) {
                            case 1:
                                color = ngoaiGio.soGio ? "white" : "#d9d9d9";
                                break;
                            case 2:
                                color = "rgb(45, 183, 245)";
                                break;
                            case 3:
                                color = "rgb(135, 208, 104)";
                                break;
                        }

                        return <InputNumber min={0} max={8} style={{ width: "100%", backgroundColor: color }} value={ngoaiGio.soGio}
                            onChange={(e: any) => {
                                ngoaiGio.soGio = e == null ? 0 : e;
                                setDataChamCong([...(dataChamCong || [])]);
                            } } />
                    }
                }
            })
        }

        columns.push({
            title: "Thống kê",
            key: "tangca",
            align: "center",
            children: groupTangCa
        });
        setTableColumns(columns);
    }


    const groupTangCa: ColumnsType<CongNgoaiGioNhanVien> = [];
    groupTangCa.push({
        title: <label className="mb-0" title="Ngày thường">NT</label>,
        key: "tangcangaythuong",
        align: "center",
        width: "50px",
        render: (value, record: CongNgoaiGioNhanVien, index) => {
            let soGio = 0;
            record.ngoaiGio.forEach(x => {
                if (x.loaiNgoaiGio == loaiNgoaiGio.ngayThuong) {
                    soGio += x.soGio;
                }
            });
            return soGio;
        }
    });

    groupTangCa.push({
        title: <label className="mb-0" title="Cuối tuần">CT</label>,
        key: "tangcacuoituan",
        align: "center",
        width: "50px",
        render: (value, record: CongNgoaiGioNhanVien, index) => {
            let soGio = 0;
            record.ngoaiGio.forEach(x => {
                if (x.loaiNgoaiGio == loaiNgoaiGio.cuoiTuan) {
                    soGio += x.soGio;
                }
            });
            return soGio;
        }
    });

    groupTangCa.push({
        title: <label className="mb-0" title="Ngày lễ">NL</label>,
        key: "tangcangayle",
        align: "center",
        width: "50px",
        render: (value, record: CongNgoaiGioNhanVien, index) => {
            let soGio = 0;
            record.ngoaiGio.forEach(x => {
                if (x.loaiNgoaiGio == loaiNgoaiGio.ngayLe) {
                    soGio += x.soGio;
                }
            });
            return soGio;
        }
    });

    const eventSaveChamCong = async () => {
        if (isLoading) return;
        form.validateFields().then(async (values) => {
            dispatch(showLoadingScreen());
            setIsLoading(true);
            try {
                var request = {
                    id: idChamCong,
                    idDonVi: values.idDonVi,
                    thangNam: values.thang.$d,
                    nhanVien: dataChamCong
                };
                const data = await luuChamNgoaiGio(request);
                toast.success("Lưu chấm thêm giờ thành công.");
                setIsReloadPage(true);
                if (idChamCong == 0) {
                    setIdChamCong(data.id);
                    navigate(Links.ChamCong.ChiTietChamNgoaiGio + "?id=" + data.id);
                }
            } catch (error: any) {
                toast.error(error);
            }
            dispatch(hideLoadingScreen());
            setIsLoading(false);
        }).catch((e) => {
            toast.error("Có lỗi xảy ra. Vui lòng thử lại sau.");
        });
    }

    const eventThuHoiChamCong = async () => {
        try {
            await thuHoiNgoaiGio(idChamCong);
            toast.success("Thu hồi chấm thêm giờ thành công.");
            setIsReloadPage(true);
        } catch (error: any) {
            toast.error("Có lỗi xảy ra. Vui lòng thử lại sau.");
        }
    }


    const eventTrinhLDPhongPheDuyet = async () => {
        try {
            await trinhLDPhongNgoaiGio(idChamCong);
            toast.success("Trình lãnh đạo phòng thành công.");
            setTrangThai(trangThaiChamCong.trinhLDPhong);
            setIsReloadPage(true);
        } catch (error: any) {
            toast.error("Có lỗi xảy ra. Vui lòng thử lại sau.");
        }
    }

    const eventLDPhongDuyetChamCong = async () => {
        eventLDPhongPheDuyetChamCong(true);
    }

    const eventLDPhongKhongDuyetChamCong = async () => {
        eventLDPhongPheDuyetChamCong(false);
    }

    const eventLDPhongPheDuyetChamCong = async (duyet: boolean) => {
        try {
            await lDPhongDuyetNgoaiGio({
                id: idChamCong,
                isDuyet: duyet,
                lyDo: lyDoTraLai
            });

            toast.success(duyet ? "Trình Lãnh đạo phụ trách thành công." : "Trả lại thành công.")
            setIsReloadPage(true);
        } catch (error: any) {
            toast.error(error);
        }
    }
    const eventLDPhuTrachDuyetChamCong = async () => {
        eventLDPhuTrachPheDuyetChamCong(true);
    }

    const eventLDPhuTrachKhongDuyetChamCong = async () => {
        eventLDPhuTrachPheDuyetChamCong(false);
    }

    const eventLDPhuTrachPheDuyetChamCong = async (duyet: boolean) => {
        try {
            await lDPhuTrachDuyetNgoaiGio({
                id: idChamCong,
                isDuyet: duyet,
                lyDo: lyDoTraLai
            });
            toast.success(duyet ? "Phê duyệt thành công." : "Trả lại thành công.");
            setIsReloadPage(true);
        } catch (error: any) {
            toast.error(error);
        }
    }

    const eventXoaNgoaiGio = async () => {
        try {
            await xoaNgoaiGio(idChamCong);
            toast.success("Xóa thành công.");
            navigate(menu[Links.ChamCong.QuanTriChamNgoaiGio] ? Links.ChamCong.QuanTriChamNgoaiGio : "/");
        } catch (error: any) {
            toast.error(error);
        }
    }

    const layChamNgoaiGio = async (id: number) => {
        try {
            setIsLoading(true);
            var data = await layNgoaiGio(id);
            setIdNhanVien(data.idNVKhoiTao);
            setIdDonVi(data.idDonVi);
            form.setFieldsValue({
                idDonVi: data.idDonVi,
                thang: dayjs(data.thangNam, "MM/YYYY")
            });

            setTongNgayTrongThang(data.ngayTrongThang);
            setTrangThai(data.trangThai);
            setDataChamCong(data.nhanVien);
            setDSNgayThuTheoThang(data.nhanVien[0].ngoaiGio);
            setLogs(data.logs);
        } catch (e) {
            toast.error("Không thể lấy thông tin bảng chấm công");
        }
        setIsLoading(false);
    }

    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        let id = +(params.get('id') || '');
        setIdChamCong(+id);
    }, []);

    useEffect(() => {
        if (isReloadPage) {
            if (idChamCong > 0) {
                layChamNgoaiGio(idChamCong);
            }

            setIsReloadPage(false);
        }
    }, [isReloadPage]);

    useEffect(() => {
        if (idChamCong > 0) {
            layChamNgoaiGio(idChamCong);
        }
    }, [idChamCong]);

    useEffect(() => {
        renderColumnsTable();
    }, [tongNgayTrongThang, trangThai]);

    var tag = (<Tag color="default"></Tag>);
    switch (trangThai) {
        case trangThaiChamCong.khoiTao: tag = (<Tag color="processing">Khởi tạo</Tag>); break;
        case trangThaiChamCong.thuHoi: tag = (<Tag color="warning">Thu hồi</Tag>); break;
        case trangThaiChamCong.trinhLDPhong: tag = (<Tag color="purple">Trình lãnh đạo phòng</Tag>); break;
        case trangThaiChamCong.lDPhongTraLai: tag = (<Tag color="error">Lãnh đạo phòng từ chối</Tag>); break;
        case trangThaiChamCong.trinhLDPhuTrach: tag = (<Tag color="cyan">Trình lãnh đạo phụ trách</Tag>); break;
        case trangThaiChamCong.lDPhuTrachTraLai: tag = (<Tag color="error">Lãnh đạo phụ trách từ chối</Tag>); break;
        case trangThaiChamCong.lDPhuTrachDuyet: tag = (<Tag color="success">Thành công</Tag>); break;
    }

    return (
        <section>
            <ContentHeader title="Chấm công thêm giờ" />
            <Row>
                <Col span="24">
                    <div className="card-outline">
                        <Tabs
                            tabBarExtraContent={
                                <Space>
                                    {
                                        trangThai == trangThaiChamCong.trinhLDPhuTrach && menu[Links.ChamCong.LDPhuTrachDuyetNgoaiGio] && <Button
                                            loading={isLoading}
                                            type="primary"
                                            className="hrm-btn-delete"
                                            icon={<CloseOutlined rev="" />}
                                            onClick={() => {
                                                setTraLaiModal(true);
                                            }}
                                        >
                                            Trả lại
                                        </Button>
                                    }
                                    {
                                        trangThai == trangThaiChamCong.trinhLDPhuTrach && menu[Links.ChamCong.LDPhuTrachDuyetNgoaiGio] && <Button
                                            loading={isLoading}
                                            type="primary"
                                            icon={<CheckOutlined rev="" />}
                                            onClick={() => {
                                                setConfirmModal({
                                                    isShowModal: true,
                                                    title: "Duyệt chấm công",
                                                    content:
                                                        <>Bạn có muốn <label> duyệt</label> bảng chấm ngoài giờ này không?</>,
                                                    onSubmit: eventLDPhuTrachDuyetChamCong
                                                });
                                            }}
                                        >
                                            Duyệt
                                        </Button>
                                    }
                                    {
                                        (trangThai == trangThaiChamCong.trinhLDPhong || trangThai == trangThaiChamCong.lDPhuTrachTraLai) && menu[Links.ChamCong.LDPhongDuyetNgoaiGio] && <Button
                                            loading={isLoading}
                                            type="primary"
                                            className="hrm-btn-delete"
                                            icon={<CloseOutlined rev="" />}
                                            onClick={() => {
                                                setTraLaiModal(true);
                                            }}
                                        >
                                            Trả lại
                                        </Button>
                                    }
                                    {
                                        (trangThai == trangThaiChamCong.trinhLDPhong || trangThai == trangThaiChamCong.lDPhuTrachTraLai) && menu[Links.ChamCong.LDPhongDuyetNgoaiGio] && <Button
                                            loading={isLoading}
                                            type="primary"
                                            icon={<SendOutlined rev="" />}
                                            onClick={() => {
                                                setConfirmModal({
                                                    isShowModal: true,
                                                    title: "Trình LĐ Phụ trách",
                                                    content:
                                                        <>Bạn có muốn <label>trình</label> Lãnh đạo phụ trách duyệt bảng chấm công này không?</>,
                                                    onSubmit: eventLDPhongDuyetChamCong
                                                });
                                            }}
                                        >
                                            Trình LĐ Phụ trách
                                        </Button>
                                    }
                                    {
                                        (trangThai == trangThaiChamCong.khoiTao || trangThai == trangThaiChamCong.thuHoi || trangThai == trangThaiChamCong.lDPhongTraLai) && menu[Links.ChamCong.XoaNgoaiGio] && idDonVi == user.idDonVi && <Button
                                            loading={isLoading}
                                            className="hrm-btn-delete"
                                            icon={<CloseOutlined rev="" />}
                                            onClick={() => {
                                                setConfirmModal({
                                                    isShowModal: true,
                                                    title: "Xóa chấm công",
                                                    content: <>Bạn có muốn <label>Xóa</label> bảng chấm công này không?</>,
                                                    onSubmit: eventXoaNgoaiGio
                                                });
                                            }}
                                        >
                                            Xóa
                                        </Button>
                                    }
                                    {
                                        (trangThai == trangThaiChamCong.khoiTao || trangThai == trangThaiChamCong.thuHoi || trangThai == trangThaiChamCong.lDPhongTraLai) && user.idDonVi == idDonVi && menu[Links.ChamCong.TrinhNgoaiGio] && <Button
                                            loading={isLoading}
                                            type="primary"
                                            icon={<SendOutlined rev="" />}
                                            onClick={() => {
                                                setConfirmModal({
                                                    isShowModal: true,
                                                    title: "Trình Lãnh đạo phòng duyệt ",
                                                    content: "Bạn có muốn trình duyệt ngoài giờ hay không?",
                                                    onSubmit: eventTrinhLDPhongPheDuyet
                                                });
                                            }}
                                        >
                                            Trình LĐ phòng
                                        </Button>
                                    }
                                    {
                                        (trangThai <= trangThaiChamCong.khoiTao || (trangThai == trangThaiChamCong.thuHoi || trangThai == trangThaiChamCong.lDPhongTraLai) && user.idDonVi == idDonVi) && menu[Links.ChamCong.ThemNgoaiGio] && <Button
                                            loading={isLoading}
                                            type="primary"
                                            icon={<SaveOutlined rev="" />}
                                            onClick={eventSaveChamCong}
                                        >
                                            Lưu chấm công
                                        </Button>
                                    }
                                    {
                                        // Button thu hồi  chấm công
                                        trangThai == trangThaiChamCong.trinhLDPhong && idDonVi == user.idDonVi
                                        && menu[Links.ChamCong.ThemNgoaiGio] &&
                                        <Button
                                            loading={isLoading}
                                            className="hrm-btn hrm-btn-warning"
                                            icon={<UndoOutlined rev="" />}
                                            onClick={() => {
                                                setConfirmModal({
                                                    isShowModal: true,
                                                    title: "Thu hồi chấm ngoài giờ",
                                                    content:
                                                        <>Bạn có muốn <label>Thu hồi</label> bảng chấm ngoài giờ này không?</>,
                                                    onSubmit: eventThuHoiChamCong
                                                });
                                            }}
                                        >
                                            Thu hồi
                                        </Button>
                                    }
                                </Space>}
                            defaultActiveKey="1"
                            onChange={(key) => {
                                if (key != "1") {
                                    setShowDetail(false);
                                } else setShowDetail(true);
                            }}
                            items={[
                                {
                                    key: "1",
                                    label: "Chấm công thêm giờ",
                                    children:
                                        <Row>
                                            <Col span="24" className="card card-body">
                                                <Form layout="vertical" form={form} validateMessages={validateMessages} disabled={trangThai > 0}>
                                                    <Row>
                                                        <Col span="12" >
                                                            <Form.Item label="Phòng ban" name="idDonVi" className="pr-1"
                                                                rules={[
                                                                    {
                                                                        required: true
                                                                    }
                                                                ]}>
                                                                <DonViSelectTree name="idDonVi" donViQuanLy />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span="12">
                                                            <Form.Item label="Tháng chấm công" name="thang" className="pl-1"
                                                                rules={[
                                                                    {
                                                                        required: true
                                                                    }
                                                                ]}
                                                            >
                                                                <DatePicker changeOnBlur={true} style={{ width: "100%" }} placeholder="Tháng chấm công" format={["MM/YYYY", "MMYYYY"]} picker="month"
                                                                />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        {
                                                            trangThai <= 3 &&
                                                            <Col span="16">
                                                                <Form.Item label="Chấm công" >
                                                                    <Row>
                                                                        <Space>
                                                                            <Button
                                                                                onClick={taiDuLieuChamCong}
                                                                                type="primary"
                                                                                loading={isLoading}
                                                                                icon={<ReloadOutlined rev="" />}>
                                                                                Tải dữ liệu chấm công
                                                                            </Button>
                                                                            <Button
                                                                                onClick={() => setShowModal(true)}
                                                                                type="primary"
                                                                                loading={isLoading}
                                                                                icon={<UploadOutlined rev="" />}>
                                                                                Import file chấm công
                                                                            </Button>
                                                                            <Button
                                                                                className="hrm-btn-success"
                                                                                onClick={taiFileMau}
                                                                                loading={isLoading}
                                                                                icon={<DownloadOutlined rev="" />}
                                                                            >
                                                                                Tải file mẫu
                                                                            </Button>
                                                                        </Space>
                                                                    </Row>

                                                                </Form.Item>
                                                            </Col>
                                                        }
                                                        {
                                                            trangThai >= 0 &&
                                                            <Col span="8">
                                                                <Form.Item label="Trạng thái">
                                                                    <label>{tag}</label>
                                                                </Form.Item>
                                                            </Col>
                                                        }
                                                    </Row>
                                                </Form>
                                            </Col>
                                        </Row>
                                },
                                {
                                    key: '2',
                                    label: "Lịch sử thao tác",
                                    children: <LogNguoiDungTable data={logs} />
                                }
                            ]}
                        />
                    </div>
                </Col>
            </Row>
            <div className="card card-primary">
                {
                    showDetail &&
                    <Table
                        sticky
                        bordered={true}
                        pagination={false}
                        loading={isLoading}
                        dataSource={(dataChamCong || []).map((x: any, idx: number) => { x.key = idx; return x; })}
                        locale={{ emptyText: "Không có dữ liệu" }}
                        columns={tableColumns}
                        scroll={{ x: 3500 }}
                    >
                    </Table>
                }             
            </div>
            <ModalTextForm
                show={confirmModal.isShowModal}
                title={confirmModal.title}
                handleClose={() => setConfirmModal({ isShowModal: false })}
                handleSave={() => {
                    confirmModal.onSubmit();
                    setConfirmModal({ isShowModal: false });
                }}
            >
                {confirmModal.content}
            </ModalTextForm>
            <ModalTextForm
                show={showModal}
                title="Chọn file chấm công"
                handleClose={() => setShowModal(false)}
                handleSave={handleUpload}
            >
                <Dropzone onDrop={handleFileChange} multiple={false}>
                    {({ getRootProps, getInputProps, isDragActive }) => (
                        <div {...getRootProps()}
                            className="hrm-dropzone-uploadfile"
                        >
                            <input {...getInputProps()} />
                            {isDragActive ? (
                                <p>Kéo và thả tệp tin ở đây...</p>
                            ) : file ? (
                                <div>
                                    <p>File đã chọn: {file?.name}</p>
                                    <p>Kích thước: {file?.size} bytes</p>
                                </div>
                            ) : (
                                <p>Kéo và thả hoặc chọn một file Excel ở đây.</p>
                            )}
                        </div>
                    )}
                </Dropzone>
            </ModalTextForm
            >{traLaiModal && <ModalTextForm show={traLaiModal}
                title="Trả lại bảng chấm công"
                handleClose={() => {
                    setLyDoTraLai("");
                    setTraLaiModal(false);
                }}
                handleSave={() => {
                    if ((trangThai == trangThaiChamCong.trinhLDPhong || trangThai == trangThaiChamCong.lDPhuTrachTraLai) && menu[Links.ChamCong.LDPhongDuyetNgoaiGio]) {
                        eventLDPhongKhongDuyetChamCong();
                    }
                    if (trangThai == trangThaiChamCong.trinhLDPhuTrach && menu[Links.ChamCong.LDPhuTrachDuyetNgoaiGio]) {
                        eventLDPhuTrachKhongDuyetChamCong();
                    }
                    setLyDoTraLai("");
                    setTraLaiModal(false);
                }}>
                <Row>
                    <Col span="24">
                        Bạn có muốn <label>Trả lại</label> bảng chấm công này khôn? Hãy nhập lý do:
                    </Col>
                </Row>
                <Row>
                    <Col span="24">
                        <TextArea rows={2} value={lyDoTraLai} onChange={(e) => {
                            setLyDoTraLai(e.target.value);
                        }} />
                    </Col>
                </Row>
            </ModalTextForm>}

        </section>
    );
};

export default ChamNgoaiGio;
